import {DoppeDtoBymoLinkViewerData} from "../types/doppe-dto-bymo-link-viewer-data";
import {OmitStrict, Values} from "@wix/devzai-utils-common";
import {DoppeViewerInvocationSource} from "./doppe-viewer-invocation-source";

export const DoppeViewerPageTypes = {
    Bypass: 'Bypass',
    Blocked: 'Blocked',
    BymoPage: 'BymoPage',
    Redirect: 'Redirect'
} as const;

export type DoppeViewerPageTypes = Values<typeof DoppeViewerPageTypes>;


export type DoppeViewerPagesData =
    | DoppeViewerPagesData.Bypass
    | DoppeViewerPagesData.Blocked
    | DoppeViewerPagesData.BymoPage
    | DoppeViewerPagesData.Redirect
;

export namespace DoppeViewerPagesData {

    interface BaseType<PAGE_TYPE extends DoppeViewerPageTypes> {
        pageType: PAGE_TYPE;
    }

    export type Bypass = BaseType<typeof DoppeViewerPageTypes.Bypass> & {
        bymoLinkViewerData: DoppeDtoBymoLinkViewerData.WithTargetUrl;
    };

    export type Redirect = BaseType<typeof DoppeViewerPageTypes.Redirect> & {
        targetUrl: string;
        cacheDurationSeconds: number | null;
    };

    export type Blocked = BaseType<typeof DoppeViewerPageTypes.Blocked> & {
        bymoLinkViewerData: DoppeDtoBymoLinkViewerData;
    };

    export type BymoPage = BaseType<typeof DoppeViewerPageTypes.BymoPage> & {
        bymoLinkViewerData: DoppeDtoBymoLinkViewerData.WithConnectedPage;
        invocationSource: DoppeViewerInvocationSource;
        isPreviewMode: boolean;
    };
}

export function doppeViewerPageDataCreateBymoPage(
    options: OmitStrict<DoppeViewerPagesData.BymoPage, 'pageType'>
) : DoppeViewerPagesData.BymoPage {
    return {
        pageType: DoppeViewerPageTypes.BymoPage,
        ...options
    }
}